
import dayjs from "dayjs"
import { getLanguage } from "@/plugins/i18n"

// 将数组数据分行
function arrayToRow(arr, row = 3) {
  if (!arr) return []
  const result = []
  let output = []
  for (let i = 0; i < arr.length; i++) {
    if (i % row === 0 && i !== 0) {
      result.push([...output])
      output = [arr[i]]
    } else {
      output.push(arr[i])
    }
  }
  result.push([...output])
  return result
}

export default {
  props: {
    shipTimeItemList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeText: "",
      isShow: true,
      rowIndex: 0,
      list: []
    }
  },
  watch: {
    shipTimeItemList: {
      handler(newVal) {
        const selected1 = newVal.find(v => v.selected)
        const selected2 = selected1 && selected1.timeList_ ? selected1.timeList_.find(v => v.selected) : null
        if (selected1 && selected2) {
          // this.activeText = selected1.dateText + ' At ' + selected2.value;
          this.activeText = this.getViewDate(selected1.date) + ", " + selected2.value
        }
        newVal = this.formatDateText(newVal)
        const list = this.addEmptyTimeRange(newVal)
        this.list = arrayToRow(list, 3)
        console.log(this.list)
      },
      immediate: true
    }
  },
  methods: {
    addEmptyTimeRange(timeRange) {
      if (timeRange.length < 2) return timeRange
      const newTimeRange = []
      let preTimeRange = timeRange[0]
      newTimeRange.push(preTimeRange)
      let curTimeRange
      let i = 1
      let count = 0
      while (i < timeRange.length) {
        if (count > 10) break // 最多循环10次，防止循环不终止
        const nextDate = dayjs(preTimeRange.date).add(1, "day").format("YYYY-MM-DD")
        if (timeRange[i].date === nextDate) {
          curTimeRange = timeRange[i]
          newTimeRange.push(curTimeRange)
          i++
        } else {
          const day = dayjs(nextDate)
          curTimeRange = {
            date: nextDate,
            dateText:
              getLanguage() == "en_US"
                ? `${this.$t("checkout.week")[day.day()]}, ${day.date()} ${this.$t("checkout.month")[day.month()]}`
                : `${this.$t("checkout.month")[day.month()]}${day.date()}日（${this.$t("checkout.week")[day.day()]}）`,
            selected: false,
            timeList_: []
          }
          newTimeRange.push(curTimeRange)
        }
        preTimeRange = curTimeRange
        count++
      }
      return newTimeRange
    },
    getViewDate(date) {
      date = dayjs(date)
      return getLanguage() == "en_US"
        ? `${this.$t("checkout.week")[date.day()]}, ${date.date()} ${this.$t("checkout.month")[date.month()]}`
        : `${this.$t("checkout.month")[date.month()]}${date.date()}日（${this.$t("checkout.week")[date.day()]}）`
    },
    formatDateText(timeRange) {
      return (
        timeRange &&
        timeRange.map(v => {
          const day = dayjs(v.date)
          return {
            ...v,
            dateText:
              getLanguage() == "en_US"
                ? `${this.$t("checkout.week")[day.day()]}, ${day.date()} ${this.$t("checkout.month")[day.month()]}`
                : `${this.$t("checkout.month")[day.month()]}${day.date()}日（${this.$t("checkout.week")[day.day()]}）`
          }
        })
      )
    },
    choseTime(v, item) {
      // this.activeText = v.dateText + ' At ' + item.value;
      this.activeText = this.getViewDate(v.date) + ", " + item.value
      this.$emit("changed", {
        shipmentDate: v.date,
        shipmentTime: item.value
      })
    },
    handleBack() {
      this.rowIndex--
    },
    handleForward() {
      this.rowIndex++
    }
  }
}
